import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.PasswordsRestService
 * @augments rest.services.BaseRestService
 *
 * @description
 * This class contains methods used to update user passwords
 * using http requests.
 */
export default class PasswordsRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
     * @ngdoc function
     * @name rest.services.PasswordsRestService#resetPassword
     * @methodOf rest.services.PasswordsRestService
     * @function
     *
     * @description
     * This method will make a http request (POST) with the user's email
     * and after that the backend will send the reset password link.
     *
     * @param {object} payload  The payload will contain the partner and the user's email.
     *
     * @returns {Promise} The promise of the call.
     */
    post(payload, headers) {

        return super.post(payload, 'passwords/', headers);

    }

    /**
     * @ngdoc function
     * @name rest.services.PasswordsRestService#update
     * @methodOf rest.services.PasswordsRestService
     * @function
     *
     * @description
     * Updates user password.
     *
     * @param {object} payload New password payload
     *
     * @returns {Promise} The promise of the call.
     */
    update(payload, headers) {

        return super.update(null, payload, 'passwords/', headers);

    }

}

_serviceDependencies.push(PasswordsRestService);

angular.module('rest.services')
    .service('PasswordsRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/passwords.js